import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
const SuggestedRepliesOption: LazyOption = createLazyOption(
    {
        key: 'SuggestedReplies',
        titleStringKey: 'optionTitle_suggestedReplies',
        searchTermsStringKey: 'optionTitle_suggestedReplies',
    },
    lazyFullModule,
    m => m.default
);
export default SuggestedRepliesOption;
